export const TEST_ID = 'mainNavigationLink';
